module.exports = __webpack_public_path__ + "static/img/off_code.8041929.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public/off_code.jpg
// module id = A0PG
// module chunks = 9